var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-form",
        {
          ref: "会员卡表单",
          staticClass: "form-box",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-width": "120px",
            "label-position": "right",
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        "label-width": "120px",
                        prop: "price",
                        label: "会员价格：",
                      },
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          precision: 2,
                          step: 0.01,
                          min: "0.01",
                          max: 99999999,
                        },
                        model: {
                          value: _vm.formData.price,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "price", $$v)
                          },
                          expression: "formData.price",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        "label-width": "120px",
                        prop: "isOpen",
                        label: "是否启用：",
                      },
                    },
                    [
                      _c("el-switch", {
                        attrs: { "active-text": "是", "inactive-text": "否" },
                        model: {
                          value: _vm.formData.isOpen,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "isOpen", $$v)
                          },
                          expression: "formData.isOpen",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "会员购买前的宣传图：",
                        prop: "photo",
                        "label-width": "120px",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "acea-row upLoadPicBox row-middle" },
                        [
                          _vm.formData.photo
                            ? _c(
                                "div",
                                { staticClass: "pictrue" },
                                [
                                  _c("el-image", {
                                    staticClass: "image",
                                    attrs: {
                                      src: _vm.formData.photo,
                                      "preview-src-list": [_vm.formData.photo],
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "el-icon-error btndel",
                                    on: { click: _vm.delPhoto },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "upLoad",
                                  on: { click: _vm.addPhoto },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-camera cameraIconfont",
                                  }),
                                ]
                              ),
                          _vm._v(" "),
                          _c("div", { staticClass: "tip-box" }, [
                            _vm._v("（建议尺寸：750 x 1334）"),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-table-item",
                      attrs: {
                        label: "权益信息设置：",
                        rules: [{ required: true }],
                        "label-width": "120px",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "table-box" },
                        [
                          _c("div", { staticClass: "tr-box" }, [
                            _c("div", { staticClass: "th-box th-border" }, [
                              _vm._v("权益标题"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "th-box th-border" }, [
                              _vm._v("权益描述"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "th-box th-border" }, [
                              _vm._v("权益图标"),
                              _c("br"),
                              _vm._v("（建议尺寸：80 x 80）"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "th-box th-border" }, [
                              _vm._v("操作"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.formData.rights.length > 0
                            ? _vm._l(
                                _vm.formData.rights,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    { key: item.id, staticClass: "tr-box" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "td-box td-border" },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "180px" },
                                            attrs: {
                                              placeholder: "请输入标题",
                                              maxlength: "10",
                                            },
                                            model: {
                                              value: item.title,
                                              callback: function ($$v) {
                                                _vm.$set(item, "title", $$v)
                                              },
                                              expression: "item.title",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "td-box td-border" },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "priamry_border",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openDescriptionPop(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("设置")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "td-box td-border" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "upLoadPicBox row-middle",
                                            },
                                            [
                                              item.icon
                                                ? _c(
                                                    "div",
                                                    { staticClass: "pictrue" },
                                                    [
                                                      _c("el-image", {
                                                        staticClass: "image",
                                                        attrs: {
                                                          src: item.icon,
                                                          "preview-src-list": [
                                                            item.icon,
                                                          ],
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-error btndel",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.delImage(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass: "upLoad",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.addImage(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-camera cameraIconfont",
                                                      }),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "td-box td-border" },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "small",
                                                type: "primary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addRow(index)
                                                },
                                              },
                                            },
                                            [_vm._v("添加行")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "small",
                                                type: "danger",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteRow(index)
                                                },
                                              },
                                            },
                                            [_vm._v("删除行")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                }
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.formData.rights.length == 0
                        ? [
                            _c(
                              "div",
                              { staticClass: "table-empty-box" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "small", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addRow(-1)
                                      },
                                    },
                                  },
                                  [_vm._v("添加一行")]
                                ),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-row", [
            _c("div", { staticClass: "btn-box" }, [
              _c(
                "div",
                {
                  staticClass: "btn-item sure-btn",
                  on: { click: _vm.onSubmit },
                },
                [_vm._v("提交")]
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("pop-set-description", { ref: "设置权益信息描述弹窗" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }